//import React from 'react'
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import CallRoundedIcon from '@mui/icons-material/CallRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import MarkEmailUnreadOutlinedIcon from '@mui/icons-material/MarkEmailUnreadOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import DoneIcon from '@mui/icons-material/Done';
import SettingsIcon from '@mui/icons-material/Settings';
import PaymentsIcon from '@mui/icons-material/Payments';
import { Link } from 'react-router-dom';
import PhotoGallery from "./Photogallery";
import ProfilePic from './ProfilePic';
import { useSession } from "./SessionContext";

import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../config";
import { uploads } from "../config";

const Dashboard = () => {
    const { session } = useSession();
    const [data, setData] = useState([]);
    //const [formData, setFormData] = useState({});
    const [preview, setPreview] = useState("");

    // ✅ GET USER PERSONAL DETAILS
    useEffect(() => {
        axios
            .get(`${API_URL}/api-get-user-details.php`, {
                withCredentials: true,
            })
            .then((res) => {
                const user = res.data.data[0];
                setData(user);
                //setFormData(user); // ✅ IMPORTANT: sync editable state

                // ✅ Set image preview dynamically
                if (user.business_logo) {
                    setPreview(`${uploads}/${user.business_logo}`);
                }
            })
            .catch((err) => console.log(err));
    }, []);


    return (
        <div>
            <div className='breadcrumb'><Link to="/">Home</Link> &nbsp;:&nbsp; Dashboard</div>
            <div className='ibodywrap'>
                <div className='row'>
                    <div className='col-md-3'>
                        <div className='bd-left-panel sticky-position'>
                            <ProfilePic />
                            <div className='db-leftmenu-panel'>
                                <Link to="/dashboard" className='dbtab-menu dbm-active'><SettingsIcon /> Dashboard</Link>
                                <Link to="/personal-details" className='dbtab-menu'><SettingsIcon /> Personal Details</Link>
                                <Link to="/business-details" className='dbtab-menu'><SettingsIcon /> Business Details</Link>
                                <Link to="/contact-details" className='dbtab-menu'><SettingsIcon /> Contact Details</Link>
                                <Link to="/photo-gallery" className='dbtab-menu'><SettingsIcon /> Photo Gallery</Link>
                                <Link to="/payment" className='dbtab-menu' style={{ color: "#fff", background: "#237cdb" }}><PaymentsIcon /> Make Payment</Link>
                            </div>
                            <div className="contant-person">

                                Contact Person: <span>Rahul Chaudhary</span>
                                <Link to="/">{session?.email}</Link>
                            </div>
                            <div className='btn-box'>
                                <Link to="tel:+91 9315959130" className='contact-no'><CallRoundedIcon />+91 9315959130</Link>
                                <Link to="tel:+91 9315959130" className='whatsapp'><WhatsAppIcon />+91 9315959130</Link>
                                <Link to="tel:+91 9315959130" className='contact-no'><MarkEmailUnreadOutlinedIcon />Send Enquiry</Link>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-9'>

                        <p style={{ display: "none" }}>{data?.user_first_name || ""} {data?.user_middle_name || ""} {data?.user_last_name || ""}</p>
                        <p style={{ display: "none" }}>User ID: {session?.userid} | Category: {session?.ucategory} | Email: {session?.email}</p>

                        <div className='bd-right-panel fade-in'>
                            <div className='comp-details'>
                                <div className='logo-box'>
                                    <img src={preview || "/images/default-profile-pic.jpg"} className="fullimg" alt={data.business_fullname}
                                        onError={(e) => {
                                            e.target.onerror = null; // prevent infinite loop
                                            e.target.src = "/images/default-profile-pic.jpg";
                                        }} />
                                </div>
                                <div className='title-box'><VerifiedIcon /> {data?.user_first_name || ""} {data?.user_middle_name || ""} {data?.user_last_name || ""}</div>
                                <div className='location-box'>
                                    <FmdGoodOutlinedIcon />
                                    {data?.business_address ? `${data.business_address}, ` : ""}
                                    {data?.business_city ? `${data.business_city}, ` : ""}
                                    {data?.business_district ? `${data.business_district}, ` : ""}
                                    {data?.business_state ? `${data.business_state} - ` : ""}
                                    {data?.business_zipcode || ""}
                                </div>
                            </div>
                            <div className='clr'></div>
                            <div className='devider'></div>
                            <div className='service-box'>
                                <h2>Products:</h2>
                                <div className='services'><DoneIcon /> Medicine</div>
                                <div className='services'><DoneIcon /> Pooj Samagri</div>
                                <div className='services'><DoneIcon /> Cloths</div>
                                <div className='services'><DoneIcon /> Ladies Accessories</div>
                                <div className='services'><DoneIcon /> Dry Fruits</div>
                                <div className='services'><DoneIcon /> Potato</div>
                                <div className='services'><DoneIcon /> Onion</div>
                                <div className='services'><DoneIcon /> Garlic</div>
                                <div className='services'><DoneIcon /> Dry Fruits</div>
                                <div className='services'><DoneIcon /> Potato</div>
                                <div className='services'><DoneIcon /> Onion</div>
                                <div className='services'><DoneIcon /> Potato</div>
                                <div className='services'><DoneIcon /> Onion</div>
                                <div className='services'><DoneIcon /> Garlic</div>
                                <div className='services'><DoneIcon /> Dry Fruits</div>
                                <div className='services'><DoneIcon /> Garlic</div>
                                <div className='services'><DoneIcon /> Medicine</div>
                                <div className='services'><DoneIcon /> Pooj Samagri</div>
                                <div className='services'><DoneIcon /> Cloths</div>
                                <div className='services'><DoneIcon /> Ladies Accessories</div>
                                <div className='services'><DoneIcon /> Dry Fruits</div>
                                <div className='services'><DoneIcon /> Potato</div>
                                <div className='services'><DoneIcon /> Onion</div>
                                <div className='services'><DoneIcon /> Garlic</div>
                                <div className='services'><DoneIcon /> Dry Fruits</div>
                                <div className='services'><DoneIcon /> Potato</div>
                                <div className='services'><DoneIcon /> Onion</div>
                                <div className='services'><DoneIcon /> Potato</div>
                                <div className='services'><DoneIcon /> Onion</div>
                                <div className='services'><DoneIcon /> Garlic</div>
                                <div className='services'><DoneIcon /> Dry Fruits</div>
                                <div className='services'><DoneIcon /> Garlic</div>
                                <div className='services'><DoneIcon /> All General Products</div>
                            </div>
                            <div className='clr'></div>
                            <div className='devider'></div>
                            <div className='overview-box'>
                                <h2>Overview:</h2>
                                <div>
                                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
                                    <p>Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur?</p>
                                    <ul>
                                        <li>Listing 1</li>
                                        <li>Listing 1</li>
                                        <li>Listing 1</li>
                                        <li>Listing 1</li>
                                    </ul>
                                </div>
                            </div>
                            <div className='clr'></div>
                            <div className='devider'></div>
                            <div>
                                <PhotoGallery />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dashboard
